import { combineReducers } from 'redux';

import LevelReducer from './LevelReducer';
import ResultReducer from './ResultReducer';

export const rootReducer = combineReducers({
    LevelReducer,
    ResultReducer,
});